import { createApi } from '@reduxjs/toolkit/query/react';
import { ApiPaginationResponse, ApiResponse } from 'types';

import { apiBaseQuery } from 'modules/apiBaseQuery';

import {
  ConfirmEecsTransactionPaymentPayload,
  FetchEecsTransactionPayload,
  IEecsTransaction,
} from '../types/eecs-transaction.type';

export const eecsTransactionApi = createApi({
  reducerPath: 'eecsTransactionApi',
  baseQuery: apiBaseQuery(`${process.env.REACT_APP_API_URL}/v2/api/admin/necs/transactions`),
  endpoints: (builder) => ({
    fetchEecsTransactions: builder.query<ApiPaginationResponse<IEecsTransaction[]>, FetchEecsTransactionPayload>({
      query: (params) => ({
        url: '',
        method: 'GET',
        params,
      }),
    }),
    confirmEecsTransactionPayment: builder.mutation<ApiResponse<void>, ConfirmEecsTransactionPaymentPayload>({
      query: (payload) => ({
        url: `/${payload.id}/payment/confirm`,
        method: 'PUT',
        body: payload,
      }),
    }),
  }),
});

export const { useLazyFetchEecsTransactionsQuery, useConfirmEecsTransactionPaymentMutation } = eecsTransactionApi;
